import type { FC } from "react";
import { CHART_HEIGHT } from "app/pages/industry-analysis/players/table/bubble-chart/const";
import { NoDataWithCTAWrapper } from "pro-features/components/NoData/src/NoDataWithCTAWrapper";
import styled from "styled-components";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { NoDataLandscape } from "pro-features/components/NoData/src/NoData";
import { translate } from "app/filters/i18nFilter";
import { allTrackers } from "app/services/track/track";
import { ETypes } from "app/pages/industry-analysis/players/table/bubble-chart/types";

interface IKey {
    title?: string;
    subtitle?: string;
}

interface ICustomNoData {
    type: ETypes;
    selectedTabRequiresPeriodOverPeriodChange: boolean;
    isPeriodOverPeriodChangeAvailable: boolean;
    isSelectedTabNotSupportedDoeToSegments: boolean;
}

const NoDataContainer = styled(FlexColumn)`
    justify-content: center;
    height: ${CHART_HEIGHT.length}${CHART_HEIGHT.unit};
    margin: 48px;
`;

export const CustomNoData: FC<ICustomNoData> = (props) => {
    const {
        type,
        selectedTabRequiresPeriodOverPeriodChange,
        isPeriodOverPeriodChangeAvailable,
        isSelectedTabNotSupportedDoeToSegments,
    } = props;

    if (selectedTabRequiresPeriodOverPeriodChange) {
        const onCtaClickCallback = () => {
            const customAttributes = { QuadrantType: ETypes[type] };
            allTrackers.dispatchTrackEvent("Button", "click", "Quadrant NA/open duration filter", customAttributes);
        };

        if (!isPeriodOverPeriodChangeAvailable) {
            return (
                <NoDataContainer>
                    <NoDataWithCTAWrapper
                        title={translate("market.research.players.bubble.no.data.pop.title")}
                        subtitle={"market.research.players.bubble.no.data.pop.subtitle"}
                        ctaKey={"market.research.players.bubble.no.data.pop.cta"}
                        onCtaClickCallback={onCtaClickCallback}
                    />
                </NoDataContainer>
            );
        }
    }

    if (isSelectedTabNotSupportedDoeToSegments) {
        return (
            <NoData
                title="market.research.players.bubble.no.data.unsupported.tab.title"
                subtitle="market.research.players.bubble.no.data.unsupported.tab.subtitle"
            />
        );
    }

    return <NoData />;
};

export const NoData: FC<IKey> = ({
    title = "market.research.players.bubble.no.dat.title",
    subtitle = "market.research.players.bubble.no.dat.subtitle",
}) => {
    return (
        <NoDataContainer>
            <NoDataLandscape
                title={translate(title)}
                subtitle={translate(subtitle)}
            />
        </NoDataContainer>
    );
};
